/* Suprimal reviews: filters, sorting, write-a-review dialog. Reviews are stored as Suprimal's own data (sp_review). */
(function () {
  if (window.__spReviews) return;
  window.__spReviews = true;
  var WORDS = ['Tap to rate', 'Not for me', 'Could be better', 'It was okay', 'Really good', 'Love it'];
  var MINE_KEY = 'sp-rv-mine';
  var STAR = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2.8l2.8 5.9 6.4.8-4.7 4.4 1.2 6.4L12 17.2l-5.7 3.1 1.2-6.4L2.8 9.5l6.4-.8L12 2.8z" fill="currentColor"/></svg>';

  function readMine() {
    try {
      var a = JSON.parse(localStorage.getItem(MINE_KEY) || '[]');
      var cut = Date.now() - 6 * 3600 * 1000;
      return a.filter(function (x) { return x && x.at > cut; });
    } catch (e) { return []; }
  }
  function saveMine(r) {
    try { var a = readMine(); a.unshift(r); localStorage.setItem(MINE_KEY, JSON.stringify(a.slice(0, 5))); } catch (e) {}
  }
  function norm(s) { return String(s || '').replace(/\s+/g, ' ').trim().toLowerCase().slice(0, 60); }

  function starsHtml(n) {
    var h = '<span class="sp-stars" role="img" aria-label="' + n + ' out of 5 stars">';
    for (var i = 1; i <= 5; i++) h += STAR.replace('<svg ', '<svg style="opacity:' + (i <= n ? '1' : '.25') + '" ');
    return h + '</span>';
  }
  function mineCard(r) {
    var a = document.createElement('article');
    a.className = 'sp-rv-card sp-rv-card--mine is-new';
    a.setAttribute('data-rating', r.rating);
    a.setAttribute('data-ts', Math.floor(r.at / 1000));
    a.setAttribute('data-product', r.handle || '');
    a.setAttribute('data-pname', r.pname || '');
    a.setAttribute('data-mine', '1');
    var top = document.createElement('div');
    top.className = 'sp-rv-card__top';
    top.innerHTML = starsHtml(r.rating);
    var tag = document.createElement('span');
    tag.className = 'sp-rv-card__mine';
    tag.textContent = 'Your review · just now';
    top.appendChild(tag);
    a.appendChild(top);
    if (r.title) { var h = document.createElement('h3'); h.className = 'sp-rv-card__title'; h.textContent = r.title; a.appendChild(h); }
    var p = document.createElement('p');
    p.className = 'sp-rv-card__text';
    p.textContent = r.body;
    a.appendChild(p);
    var who = document.createElement('div');
    who.className = 'sp-rv-card__who';
    var av = document.createElement('span');
    av.className = 'sp-rv-card__avatar';
    av.setAttribute('aria-hidden', 'true');
    av.textContent = (r.author || '?').charAt(0).toUpperCase();
    var nm = document.createElement('span');
    nm.className = 'sp-rv-card__name';
    nm.textContent = r.author;
    who.appendChild(av);
    who.appendChild(nm);
    a.appendChild(who);
    return a;
  }

  function initList(wrap) {
    var list = wrap.querySelector('.sp-rv__list');
    if (!list) return null;
    var cards = Array.prototype.slice.call(list.querySelectorAll('.sp-rv-card'));
    var step = +list.getAttribute('data-limit') || 6;
    var st = { star: 0, prod: '', sort: 'new', shown: step };
    var moreBtn = wrap.querySelector('[data-sp-rv-more]');
    var moreRow = wrap.querySelector('.sp-rv__more');
    var statusEl = wrap.querySelector('[data-sp-rv-status]');
    var noneEl = wrap.querySelector('[data-sp-rv-none]');
    var prodSel = wrap.querySelector('[data-sp-rv-product]');
    var sortSel = wrap.querySelector('[data-sp-rv-sort]');
    var tools = wrap.querySelector('[data-sp-rv-tools]');
    var starBtns = Array.prototype.slice.call(wrap.querySelectorAll('[data-sp-rv-star]'));
    var num = function (c, k) { return +c.getAttribute(k) || 0; };
    if (prodSel) {
      var info = {}, order = [];
      cards.forEach(function (c) {
        var h = c.getAttribute('data-product');
        if (!h) return;
        if (!info[h]) { info[h] = { n: 0, name: c.getAttribute('data-pname') }; order.push(h); }
        info[h].n++;
      });
      order.sort(function (a, b) { return info[b].n - info[a].n; });
      order.forEach(function (h) {
        var o = document.createElement('option');
        o.value = h;
        o.textContent = info[h].name + ' (' + info[h].n + ')';
        prodSel.appendChild(o);
      });
      if (order.length < 2) prodSel.parentNode.hidden = true;
    }
    function render(fresh) {
      if (fresh) st.shown = step;
      var pool = cards.filter(function (c) { return !st.prod || c.getAttribute('data-product') === st.prod; });
      var count = function (s) { return s ? pool.filter(function (c) { return num(c, 'data-rating') === s; }).length : pool.length; };
      if (st.star && !count(st.star)) st.star = 0;
      starBtns.forEach(function (b) {
        var s = +b.getAttribute('data-sp-rv-star');
        var on = s === st.star;
        if (b.classList.contains('sp-rv__chip')) {
          var n = count(s);
          b.querySelector('[data-n]').textContent = n;
          b.disabled = s !== 0 && n === 0;
        }
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      var m = pool.filter(function (c) { return !st.star || num(c, 'data-rating') === st.star; });
      m.sort(function (a, b) {
        var mine = num(b, 'data-mine') - num(a, 'data-mine');
        if (mine) return mine;
        var byNew = num(b, 'data-ts') - num(a, 'data-ts');
        if (st.sort === 'high') return (num(b, 'data-rating') - num(a, 'data-rating')) || byNew;
        if (st.sort === 'low') return (num(a, 'data-rating') - num(b, 'data-rating')) || byNew;
        return byNew;
      });
      var before = cards.filter(function (c) { return !c.hidden; });
      cards.forEach(function (c) { c.hidden = true; });
      m.forEach(function (c, i) {
        list.appendChild(c);
        c.hidden = i >= st.shown;
        if (!fresh && !c.hidden && before.indexOf(c) < 0) { c.classList.remove('is-new'); void c.offsetWidth; c.classList.add('is-new'); }
      });
      if (moreBtn) moreBtn.hidden = m.length <= st.shown;
      if (moreRow) moreRow.hidden = (!moreBtn || moreBtn.hidden) && !moreRow.querySelector('.sp-rv__all');
      if (noneEl) noneEl.hidden = m.length > 0;
      if (statusEl) statusEl.textContent = m.length > 1 ? 'Showing ' + Math.min(st.shown, m.length) + ' of ' + m.length + ' reviews' : '';
    }
    starBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        var s = +b.getAttribute('data-sp-rv-star');
        var bar = b.classList.contains('sp-rv__barbtn');
        st.star = bar && st.star === s ? 0 : s;
        render(true);
        if (bar && tools && !tools.hidden && window.innerWidth < 1000) tools.scrollIntoView({ block: 'start', behavior: 'smooth' });
      });
    });
    if (prodSel) prodSel.addEventListener('change', function () { st.prod = prodSel.value; render(true); });
    if (sortSel) sortSel.addEventListener('change', function () { st.sort = sortSel.value; render(true); });
    if (moreBtn) moreBtn.addEventListener('click', function () { st.shown += step; render(false); });
    render(true);
    return {
      add: function (card) { list.insertBefore(card, list.firstChild); cards.unshift(card); st.star = 0; st.prod = ''; if (prodSel) prodSel.value = ''; render(true); },
      has: function (r) {
        var key = norm(r.body);
        return cards.some(function (c) { var t = c.querySelector('.sp-rv-card__text'); return !c.getAttribute('data-mine') && t && norm(t.textContent) === key; });
      }
    };
  }

  function showMine(wrap, listApi, r) {
    var card = mineCard(r);
    if (listApi) { listApi.add(card); return; }
    var host = wrap.querySelector('.sp-rv-empty') || wrap.querySelector('.sp-rv .sp-container');
    if (!host) return;
    var box = host.querySelector('.sp-rv-mine');
    if (!box) { box = document.createElement('div'); box.className = 'sp-rv-mine'; host.insertBefore(box, host.firstChild); }
    box.insertBefore(card, box.firstChild);
  }

  function initDialog(wrap, listApi) {
    var dlg = wrap.querySelector('[data-sp-rw]');
    if (!dlg) return;
    var root = wrap.querySelector('[data-sp-rv-root]');
    var modeName = root ? root.getAttribute('data-rw-mode') : 'forms';
    var html = document.documentElement;
    var form = dlg.querySelector('[data-sp-rw-form]');
    var done = dlg.querySelector('[data-sp-rw-done]');
    var stars = dlg.querySelector('.sp-rw__stars');
    var word = dlg.querySelector('[data-sp-rw-word]');
    var ta = form.querySelector('textarea');
    var count = form.querySelector('[data-sp-rw-count]');
    var fail = form.querySelector('[data-sp-rw-fail]');
    var MIN = 20;
    var lastFocus = null;
    var closing = 0;

    function rating() { var c = form.querySelector('input[data-v]:checked'); return c ? +c.getAttribute('data-v') : 0; }
    function paint(n) { stars.setAttribute('data-show', n); word.textContent = WORDS[n]; word.classList.toggle('is-set', n > 0); }
    function field(k) { return form.querySelector('[data-sp-rw-field="' + k + '"]'); }
    function productEl() {
      var el = form.querySelector('[data-sp-rw-product]');
      if (el && el.tagName === 'SELECT') return el.options[el.selectedIndex];
      return el;
    }
    function ok(k) {
      var el;
      if (k === 'rating') return rating() > 0;
      if (k === 'product') { el = form.querySelector('select[data-sp-rw-product]'); return !el || !!el.value; }
      if (k === 'body') return ta.value.trim().length >= MIN;
      if (k === 'name') return form.elements['contact[name]'].value.trim().length > 0;
      if (k === 'email') { el = form.elements['contact[email]']; el.value = el.value.trim(); return el.value.indexOf('@') > 0 && el.checkValidity(); }
      if (k === 'consent') return field('consent').querySelector('input').checked;
      return true;
    }
    function check(k) {
      var f = field(k);
      if (!f) return true;
      var good = ok(k);
      f.classList.toggle('is-invalid', !good);
      var el = f.querySelector('.sp-rw__input');
      if (el) el.setAttribute('aria-invalid', good ? 'false' : 'true');
      return good;
    }
    function setRating(n) {
      var el = form.querySelector('input[data-v="' + n + '"]');
      if (el) el.checked = true;
      paint(rating());
      if (field('rating').classList.contains('is-invalid')) check('rating');
    }
    function counter() {
      var n = ta.value.trim().length;
      count.textContent = n === 0 ? MIN + ' characters minimum' : (n < MIN ? (MIN - n) + ' more to go' : n + ' / 2000');
      count.classList.toggle('is-ok', n >= MIN);
    }
    function open(n) {
      if (closing) { clearTimeout(closing); closing = 0; }
      lastFocus = document.activeElement;
      if (n) setRating(n);
      if (!dlg.open) { if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', ''); }
      html.classList.add('sp-rw-lock');
      dlg.classList.remove('is-out');
      requestAnimationFrame(function () { requestAnimationFrame(function () { dlg.classList.add('is-in'); }); });
      var fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      var target = null;
      if (!done.hidden) target = done.querySelector('button');
      else if (fine) { var ps = form.querySelector('select[data-sp-rw-product]'); target = n ? (ps && !ps.value ? ps : ta) : form.querySelector('input[data-v]'); }
      setTimeout(function () { (target || dlg.querySelector('.sp-rw__close')).focus({ preventScroll: true }); }, 80);
    }
    function close() {
      if (!dlg.open || closing) return;
      dlg.classList.remove('is-in');
      dlg.classList.add('is-out');
      closing = setTimeout(function () {
        closing = 0;
        dlg.classList.remove('is-out');
        if (dlg.close) dlg.close(); else dlg.removeAttribute('open');
        html.classList.remove('sp-rw-lock');
        if (!done.hidden) { done.hidden = true; form.hidden = false; form.reset(); paint(0); counter(); form.classList.remove('is-sending'); }
        if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
      }, 320);
    }
    function showDone(live, name) {
      dlg.querySelector('[data-sp-rw-name]').textContent = name ? ', ' + name : '';
      dlg.querySelector('[data-sp-rw-done-live]').hidden = !live;
      dlg.querySelector('[data-sp-rw-done-mail]').hidden = live;
      dlg.querySelector('[data-sp-rw-done-ey]').textContent = live ? 'Review published' : 'Review received';
      form.hidden = true;
      done.hidden = false;
      setTimeout(function () { done.querySelector('button').focus({ preventScroll: true }); }, 60);
    }
    dlg.addEventListener('close', function () { html.classList.remove('sp-rw-lock'); dlg.classList.remove('is-in', 'is-out'); });
    dlg.addEventListener('cancel', function (e) { e.preventDefault(); close(); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
    wrap.addEventListener('click', function (e) {
      var o = e.target.closest('[data-sp-rw-open]');
      if (o) { e.preventDefault(); open(+o.getAttribute('data-sp-rw-open') || 0); return; }
      if (e.target.closest('[data-sp-rw-close]')) close();
    });
    Array.prototype.forEach.call(wrap.querySelectorAll('.sp-rw-cta__stars'), function (g) {
      var hint = g.parentNode.querySelector('[data-sp-rw-hint]');
      var base = hint ? hint.textContent : '';
      Array.prototype.forEach.call(g.querySelectorAll('[data-sp-rw-open]'), function (b) {
        var v = +b.getAttribute('data-sp-rw-open');
        function show() { g.setAttribute('data-show', v); if (hint) hint.textContent = WORDS[v]; }
        b.addEventListener('mouseenter', show);
        b.addEventListener('focus', show);
      });
      function reset() { g.setAttribute('data-show', 0); if (hint) hint.textContent = base; }
      g.addEventListener('mouseleave', reset);
      g.addEventListener('focusout', function (e) { if (!g.contains(e.relatedTarget)) reset(); });
    });
    Array.prototype.forEach.call(stars.querySelectorAll('label'), function (l, idx) {
      l.addEventListener('mouseenter', function () { paint(idx + 1); });
    });
    stars.addEventListener('mouseleave', function () { paint(rating()); });
    form.addEventListener('change', function (e) {
      if (e.target.hasAttribute('data-v')) { paint(rating()); check('rating'); }
      var f = e.target.closest('[data-sp-rw-field]');
      if (f && f.classList.contains('is-invalid')) check(f.getAttribute('data-sp-rw-field'));
    });
    form.addEventListener('input', function (e) {
      if (e.target === ta) counter();
      var f = e.target.closest('[data-sp-rw-field]');
      if (f && f.classList.contains('is-invalid')) check(f.getAttribute('data-sp-rw-field'));
    });

    form.addEventListener('submit', function (e) {
      var keys = ['rating', 'product', 'body', 'name', 'email', 'consent'];
      var first = null;
      keys.forEach(function (k) { if (!check(k) && !first) first = k; });
      if (first) {
        e.preventDefault();
        e.stopImmediatePropagation();
        var f = field(first);
        var el = f.querySelector('.sp-rw__input, input');
        f.scrollIntoView({ block: 'center', behavior: 'smooth' });
        if (el) setTimeout(function () { el.focus({ preventScroll: true }); }, 250);
        var btn = form.querySelector('.sp-rw__submit');
        btn.classList.remove('is-shake');
        void btn.offsetWidth;
        btn.classList.add('is-shake');
        return;
      }
      var pe = productEl();
      var data = {
        rating: rating(),
        title: form.elements['contact[Headline]'].value.trim(),
        body: ta.value.trim(),
        author: form.elements['contact[name]'].value.trim(),
        email: form.elements['contact[email]'].value.trim(),
        productId: pe ? pe.getAttribute('data-pid') : '',
        handle: pe ? pe.getAttribute('data-handle') : '',
        pname: pe ? (pe.value || pe.textContent || '').replace(/ Strips$/, '') : '',
        at: Date.now()
      };
      var engine = window.SPReviewEngine;
      if (modeName === 'forms' && engine && typeof engine.send === 'function') {
        e.preventDefault();
        e.stopImmediatePropagation();
        if (fail) fail.hidden = true;
        form.classList.add('is-sending');
        form.querySelector('.sp-rw__submit').setAttribute('aria-busy', 'true');
        engine.send(data).then(function () {
          form.classList.remove('is-sending');
          form.querySelector('.sp-rw__submit').removeAttribute('aria-busy');
          saveMine(data);
          document.querySelectorAll('.shopify-section').forEach(function (sec) {
            if (sec.__spRv && sec.__spRv.mineShown !== data.at) { sec.__spRv.mineShown = data.at; showMine(sec, sec.__spRv.list, data); }
          });
          showDone(true, data.author.split(' ')[0]);
        }).catch(function () {
          form.classList.remove('is-sending');
          form.querySelector('.sp-rw__submit').removeAttribute('aria-busy');
          if (fail) { fail.hidden = false; fail.scrollIntoView({ block: 'center', behavior: 'smooth' }); }
        });
        return;
      }
      try { sessionStorage.setItem('sp-rw-name', data.author.split(' ')[0]); } catch (err) {}
      form.classList.add('is-sending');
      form.querySelector('.sp-rw__submit').setAttribute('aria-busy', 'true');
    }, true);
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) { form.classList.remove('is-sending'); form.querySelector('.sp-rw__submit').removeAttribute('aria-busy'); }
    });

    if (form.querySelector('[data-sp-rw-posted]')) {
      var nm = '';
      try { nm = sessionStorage.getItem('sp-rw-name') || ''; sessionStorage.removeItem('sp-rw-name'); } catch (err) {}
      try {
        var u = new URL(window.location.href);
        u.searchParams.delete('contact_posted');
        history.replaceState(history.state, '', u.pathname + u.search);
      } catch (err) {}
      var sec = wrap.querySelector('.sp-rv');
      if (sec) sec.scrollIntoView({ block: 'start' });
      showDone(false, nm);
      open(0);
    } else if (form.querySelector('[data-sp-rw-errors]')) {
      open(0);
    }
  }

  function init(wrap) {
    if (wrap.__spRv) return;
    if (!wrap.querySelector('[data-sp-rv-root], [data-sp-rw]')) return;
    var listApi = initList(wrap);
    wrap.__spRv = { list: listApi, mineShown: 0 };
    initDialog(wrap, listApi);
    var pel = wrap.querySelector('[data-sp-rw-product]');
    var isAll = !!(wrap.querySelector('.sp-rv__list[data-all="1"]') || (pel && pel.tagName === 'SELECT'));
    var pageHandle = pel && pel.tagName !== 'SELECT' ? pel.getAttribute('data-handle') : '';
    readMine().forEach(function (r) {
      if (!isAll && pageHandle && r.handle !== pageHandle) return;
      if (listApi && listApi.has(r)) return;
      showMine(wrap, listApi, r);
    });
  }
  function boot() { Array.prototype.forEach.call(document.querySelectorAll('.shopify-section'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { if (e.target) init(e.target); });
})();